<template>
  <div>
    <div
      class="card spinner"
      v-if="$store.state.loader > 0"
    >
      <ProgressSpinner />
    </div>
    <section id="container">
      <HeaderSideBar :is_not_expand="is_not_expand" @call="expand()" />
      <div :class="is_not_expand ? 'not-expand' : 'expand'">
        <router-view></router-view>
      </div>
       <PrimeToast />
      <section id="main-content">
        <!-- <template> -->
          <footer class="site-footer">
            <div class="text-center">
              {{ new Date().getFullYear() }} &copy; Voyado AB
            </div>
          </footer>
        <!-- </template> -->
      </section>
    </section>
   
  </div>
</template>

<script>
import HeaderSideBar from "@/components/layout/HeaderSidebar.vue";

export default {
  components: {
    HeaderSideBar,
  },
  data() {
    return {
      is_not_expand: false,
    };
  },
  methods: {
    expand() {
      this.is_not_expand = !this.is_not_expand;
    },
  },
};
</script>

<style scoped>
.expand{
  margin-left: 210px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.not-expand{
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
</style>
